import { UtilsService } from "../services/utils.service";
import { coordinate } from "./coordinate";
import { ProcedureModel } from "./procedure";
import { ProcedurePerformanceLine } from "./procedure-performance-line";
import * as olProj from 'ol/proj';
import { MapService } from "../services/map.service";
import { Feature } from "ol";
import LineString from "ol/geom/LineString";
import { FeatureType } from "./EnumTypes";
import VectorSource from "ol/source/Vector";
import { VectorLayerDMTR } from "../menu/view-menu/layer";
import { CalculationsService } from "../services/calculations.service";
import { Fill, Stroke, Style } from "ol/style";
import { TopLevelLayers } from "../menu/view-menu/top-level-layers";
import { ModalConfirmationService } from "../services/modal-confirmation.service";
import GeoJSON from 'ol/format/GeoJSON';
import { Coordinate } from "ol/coordinate";

export class ProcedurePerformanceInertialDrift{
  private static aircraftSpeed : number = 303.8058; // Default speed (ft / sec)
	private static maxNSE : number = 0.866;
  private static worstInertialDrift : number = 8; // NM per hour or 60 seconds
  public static inertialValues : number[][] = [];
  public static coverageDistanceValues : number[][] = [];

  private static features : Feature[] = [];

  public static getInertialValues(){
    return this.inertialValues;
  }

  public static getCoverageValues(){
    return this.coverageDistanceValues;
  }

  public static getMaxNSE(){
    return this.maxNSE;
  }

  public static setMaxNSE(maxNSE : number){
    this.maxNSE = maxNSE;
  }

  public static getWorstInertialDrift(){
    return this.worstInertialDrift;
  }

  public static setWorstInertialDrift(worstInertialDrift : number){
    this.worstInertialDrift = worstInertialDrift;
  }

  public static calculateInertialDrift(procedure_type : string, aircraftSpeed : number, runawayValue : number, horizontalUnits : string, lines : ProcedurePerformanceLine[], worstValue : boolean) : Map<string,coordinate[][]>{
    let returnMap : Map<string, coordinate[][]> = new Map<string, coordinate[][]>();
    this.coverageDistanceValues = [];
    this.inertialValues = [];
    let invalid : coordinate[][] = [];
    let valid : coordinate[][] = [];
    let coverage : coordinate[][] = [];

    returnMap.set("INVALID", invalid);
    returnMap.set("VALID", valid);
    returnMap.set("COVERAGE", coverage);

    let totalMaxAllowedDriftTime : number = (this.maxNSE / this.worstInertialDrift) * 3600;

    let lastCoverageNSE : number = 0;
    let lastDistance : number = 0;
    let lastLatitude : number = 0;
    let lastLongitude : number = 0;
    let lastAltitude : number = 0;
    let afterFisrtCoverageValue : boolean = false;

    let coverageValues : number[] = [];

    // we can consider the takeoff time, but when we calculate the NSE from the
    // distance we also shall take this in account! (we shall subtract the runnaway
    // distance)
    // double onAirMaxAllowedDriftTime=totalMaxAllowedDriftTime-takeOffTime;
    let distanceWhileInertialDriftIsValidAfterSyncMeters : number = this.feetToMeters(this.aircraftSpeed * totalMaxAllowedDriftTime);

    // if Standard instrument DEPARTURE (SID)
    if (procedure_type == "0") {

      let procedureTotalDistanceInMeters : number = 0;
      let distanceSinceLastSyncInMeters : number = 0;

      let reachedInertialLimit : boolean = false;
      let isCurrentlyCovered : boolean = false;
      let invalidcoordinates : coordinate[] = [];
      let validcoordinates : coordinate[] = [];
      let coveragecoordinates : coordinate[] = [];


      let validValues : Number[] = [];

      let isTheLastValue : boolean = false;
      let validValuesClosed : boolean = false;
      let validValuesStarted : boolean = false;
      let firstCoverageAdded : boolean = false;

      for (let c : number = 0; c < lines.length; c++) {

          let line : ProcedurePerformanceLine = lines[c];

          if (c + 1 == lines.length) {

              isTheLastValue = true;
              // coverageValues.add( line.getDistance()); //TODO validate
              // inertialCoverageSeries.add(coverageValues);
          }

          // increment the distance already analyzed

          if(horizontalUnits == 'NM'){
            let lineDistanceMeters = this.nauticalMilesToMeters(line.distance);
            distanceSinceLastSyncInMeters += (lineDistanceMeters - procedureTotalDistanceInMeters);
            procedureTotalDistanceInMeters += (lineDistanceMeters - procedureTotalDistanceInMeters);
          }else {
            distanceSinceLastSyncInMeters += (line.distance - procedureTotalDistanceInMeters);
            procedureTotalDistanceInMeters += (line.distance - procedureTotalDistanceInMeters);
          }

          // if has coverage

          if ((worstValue ? line.worstValue : line.centerValue) != 8) {// TODO remove value 8....
              afterFisrtCoverageValue = true;
              if (afterFisrtCoverageValue && !firstCoverageAdded) {
                  coverageValues.push(line.distance - 1);
                  firstCoverageAdded = true;
              }

              if (isTheLastValue) {
                  coverageValues.push(line.distance);
                  this.coverageDistanceValues.push(coverageValues);
              }

              if (afterFisrtCoverageValue) {// still has coverage

                  if (!validValuesClosed) {
                      validValues.push(line.distance);
                      validValues = [];
                      validValuesClosed = true;
                  }
              }

              if(horizontalUnits == 'NM'){
                ProcedurePerformanceInertialDrift.inertialValues.push([this.metersToNauticalMiles(procedureTotalDistanceInMeters), worstValue ? line.worstNseValue : line.centerNseValue]);
              }else {
                ProcedurePerformanceInertialDrift.inertialValues.push([procedureTotalDistanceInMeters, worstValue ? line.worstNseValue : line.centerNseValue]);
              }


              lastCoverageNSE = worstValue ? line.worstNseValue : line.centerNseValue;

              if (!isCurrentlyCovered && reachedInertialLimit) {
                  invalidcoordinates.push(new coordinate(line.centerLatitude, line.centerLongitude,line.centerHeigth));
                  returnMap.get("INVALID").push(invalidcoordinates);

                  invalidcoordinates = [];

              } else if (!isCurrentlyCovered && !reachedInertialLimit) {
                  validcoordinates.push(new coordinate(line.centerLatitude, line.centerLongitude,line.centerHeigth));

                  returnMap.get("VALID").push(validcoordinates);
                  validcoordinates = [];
              }

              coveragecoordinates.push(new coordinate(line.centerLatitude, line.centerLongitude,line.centerHeigth));

              reachedInertialLimit = false;
              isCurrentlyCovered = true;
              distanceSinceLastSyncInMeters = 0;
              validValuesClosed = false;
              validValuesStarted = false;
          }
          // if does not have coverage
          else {
              // comes from a coverage loss --> first close coverage coordinates
              if (isCurrentlyCovered) {
                  // map 2d
                  // RFMA TODO
                  // coveragecoordinates.add(new
                  // coordinate(line.getCenterLongitude(),line.getCenterLatitude()));
                  coveragecoordinates.push(new coordinate(lastLatitude, lastLongitude, lastAltitude));
                  returnMap.get("COVERAGE").push(coveragecoordinates);
                  coveragecoordinates = [];

                  // plot
                  // RFMA TODO
                  // coverageValues.add( line.getDistance());
                  coverageValues.push(lastDistance);
                  this.coverageDistanceValues.push(coverageValues);
                  coverageValues = [];
                  firstCoverageAdded = false;

                  invalidcoordinates = [];
                  validValuesStarted = false;

                  // RFMA TODO
                  validcoordinates.push(new coordinate(lastLatitude, lastLongitude, lastAltitude));
              }

              if(horizontalUnits == 'NM'){
                if(afterFisrtCoverageValue) {
                  ProcedurePerformanceInertialDrift.inertialValues.push([this.metersToNauticalMiles(procedureTotalDistanceInMeters), lastCoverageNSE + this.calculateNSEByDistance(distanceSinceLastSyncInMeters, aircraftSpeed)]);
              }else {
                  ProcedurePerformanceInertialDrift.inertialValues.push([this.metersToNauticalMiles(procedureTotalDistanceInMeters), lastCoverageNSE + this.calculateNSEByDistance(distanceSinceLastSyncInMeters, aircraftSpeed) + runawayValue]);
              }
              }else {
                if(afterFisrtCoverageValue) {
                  ProcedurePerformanceInertialDrift.inertialValues.push([procedureTotalDistanceInMeters, lastCoverageNSE + this.calculateNSEByDistance(distanceSinceLastSyncInMeters, aircraftSpeed)]);
              }else {
                  ProcedurePerformanceInertialDrift.inertialValues.push([procedureTotalDistanceInMeters, lastCoverageNSE + this.calculateNSEByDistance(distanceSinceLastSyncInMeters, aircraftSpeed) + runawayValue]);
              }
              }


              isCurrentlyCovered = false;

              if (isTheLastValue && !reachedInertialLimit) {
                  validValues.push(line.distance);
              }

              if (!reachedInertialLimit && !validValuesStarted) {

                  validValues.push(line.distance);
                  validValuesStarted = true;
              }

              if ((lastCoverageNSE
                      + this.calculateNSEByDistance(distanceSinceLastSyncInMeters, aircraftSpeed)) > this.maxNSE) {
                  reachedInertialLimit = true;
              }
              if (reachedInertialLimit) {

                  if (!validValuesClosed) {
                      validValues.push(line.distance);
                      validValues = [];
                      validValuesClosed = true;
                  }

                  invalidcoordinates.push(new coordinate(line.centerLatitude, line.centerLongitude,
                          line.centerHeigth));

                  // Transition from valid to invalid. Add the valid coordinates and reset the
                  // array
                  if (validcoordinates.length > 0) {
                      validcoordinates.push(new coordinate(line.centerLatitude, line.centerLongitude,
                              line.centerHeigth));
                      returnMap.get("VALID").push(validcoordinates);
                      validcoordinates = [];
                  }
              } else {
                  // if(!(validcoordinates.size()>0)){
                  validcoordinates.push(new coordinate(line.centerLatitude, line.centerLongitude,
                          line.centerHeigth));
                  // }
              }
          }
          lastDistance = line.distance;
          lastLongitude = line.centerLongitude;
          lastLatitude = line.centerLatitude;
          lastAltitude = line.centerHeigth;
      }

      if (!isCurrentlyCovered && reachedInertialLimit) {
          returnMap.get("INVALID").push(invalidcoordinates);
      }

      if (isCurrentlyCovered && coveragecoordinates.length > 0) {
          returnMap.get("COVERAGE").push(coveragecoordinates);
      }

      if (!isCurrentlyCovered && !reachedInertialLimit) {
          returnMap.get("VALID").push(validcoordinates);
      }

      /*
      * END OF SID
      */
      // TODO
      /*
      * START OF STAR (Standard terminal ARRIVAL route)
      */
    }else {

      let procedureTotalDistanceInMeters : number = 0;
      let distanceSinceLastSyncInMeters : number = 0;

      // inertialSeries.add(UnitsConverter.metersToNauticalMiles(procedureTotalDistanceInMeters),calculateNSEByDistance(procedureTotalDistanceInMeters));

      let reachedInertialLimit : boolean = false;
      let isCurrentlyCovered : boolean = false;
      let invalidcoordinates : coordinate[] = [];
      let validcoordinates : coordinate[] = [];
      let coveragecoordinates : coordinate[] = [];

      let validValues : Number[] = [];

      let isTheLastValue : boolean = false;
      let validValuesClosed : boolean = false;
      let validValuesStarted : boolean = false;
      let firstCoverageAdded : boolean = false;

      let firstCoverageDetected : boolean = false;

      for (let c : number = 0; c < lines.length; c++) {

          let line : ProcedurePerformanceLine = lines[c];

          if (c + 1 == lines.length) {
              isTheLastValue = true;
              coverageValues.push(line.distance); // TODO validate
              this.coverageDistanceValues.push(coverageValues);
          }

          // increment the distance already analyzed

          let lineDistanceMeters = this.nauticalMilesToMeters(line.distance);
          distanceSinceLastSyncInMeters += (lineDistanceMeters - procedureTotalDistanceInMeters);
          procedureTotalDistanceInMeters += (lineDistanceMeters - procedureTotalDistanceInMeters);

          // if has coverage
          if ((worstValue ? line.worstValue : line.centerValue) != 8) {// TODO remove value 8....
              afterFisrtCoverageValue = true;
              if (afterFisrtCoverageValue && !firstCoverageAdded) {
                  coverageValues.push(line.distance - 1);
                  firstCoverageAdded = true;
              }

              if (isTheLastValue) {
                  coverageValues.push(line.distance);
                  this.coverageDistanceValues.push(coverageValues);

              }

              if (afterFisrtCoverageValue) {// still has coverage

                  if (!validValuesClosed && validValuesStarted) {
                      validValues.push(line.distance);
                      validValues = [];
                      validValuesClosed = true;
                  }

                  if(horizontalUnits == 'NM'){
                    ProcedurePerformanceInertialDrift.inertialValues.push([this.metersToNauticalMiles(procedureTotalDistanceInMeters), worstValue ? line.worstNseValue : line.centerNseValue]);
                  }else {
                    ProcedurePerformanceInertialDrift.inertialValues.push([procedureTotalDistanceInMeters, worstValue ? line.worstNseValue : line.centerNseValue]);
                  }


              }

              lastCoverageNSE = worstValue ? line.worstNseValue : line.centerNseValue;

              if (!isCurrentlyCovered && reachedInertialLimit) {

                  invalidcoordinates.push(new coordinate(line.centerLatitude, line.centerLongitude,
                          line.centerHeigth));
                  returnMap.get("INVALID").push(invalidcoordinates);

                  invalidcoordinates = [];

              } else if (!isCurrentlyCovered && !reachedInertialLimit && firstCoverageDetected) {
                  validcoordinates.push(new coordinate(line.centerLatitude, line.centerLongitude,
                          line.centerHeigth));

                  returnMap.get("VALID").push(validcoordinates);
                  validcoordinates = []
              }

              coveragecoordinates.push(new coordinate(line.centerLatitude, line.centerLongitude,
                      line.centerHeigth));

              reachedInertialLimit = false;
              isCurrentlyCovered = true;
              distanceSinceLastSyncInMeters = 0;
              validValuesClosed = false;
              validValuesStarted = false;

              firstCoverageDetected = true;
          }
          // if does not have coverage
          else {

              // while no coverage is detected
              if (!firstCoverageDetected) {
                  continue;
              }

              // if(isTheLastValue){
              // coverageValues.add( line.getDistance());
              // inertialCoverageSeries.add(coverageValues);
              // }

              // comes from a coverage loss
              if (isCurrentlyCovered) {
                  // map 2d
                  // RFMA TODO
                  // coveragecoordinates.add(new
                  // coordinate(line.getCenterLongitude(),line.getCenterLatitude()));
                  coveragecoordinates.push(new coordinate(lastLatitude, lastLongitude, lastAltitude));
                  returnMap.get("COVERAGE").push(coveragecoordinates);
                  coveragecoordinates = [];

                  // plot
                  // RFMA TODO
                  // coverageValues.add( line.getDistance());
                  coverageValues.push(lastDistance);
                  this.coverageDistanceValues.push(coverageValues);
                  coverageValues = [];
                  firstCoverageAdded = false;

                  invalidcoordinates = [];

                  // RFMA TODO
                  validcoordinates.push(new coordinate(lastLatitude, lastLongitude, lastAltitude));

              }

              if(horizontalUnits == 'NM'){
                if(afterFisrtCoverageValue){
                  ProcedurePerformanceInertialDrift.inertialValues.push([this.metersToNauticalMiles(procedureTotalDistanceInMeters), lastCoverageNSE + this.calculateNSEByDistance(distanceSinceLastSyncInMeters, aircraftSpeed)]);
                }else {
                  ProcedurePerformanceInertialDrift.inertialValues.push([this.metersToNauticalMiles(procedureTotalDistanceInMeters), lastCoverageNSE + this.calculateNSEByDistance(distanceSinceLastSyncInMeters, aircraftSpeed) + runawayValue]);
                }
              }else {
                if(afterFisrtCoverageValue){
                  ProcedurePerformanceInertialDrift.inertialValues.push([procedureTotalDistanceInMeters, lastCoverageNSE + this.calculateNSEByDistance(distanceSinceLastSyncInMeters, aircraftSpeed)]);
                }else {
                  ProcedurePerformanceInertialDrift.inertialValues.push([procedureTotalDistanceInMeters, lastCoverageNSE + this.calculateNSEByDistance(distanceSinceLastSyncInMeters, aircraftSpeed) + runawayValue]);
                }
              }

              isCurrentlyCovered = false;

              if (isTheLastValue && !reachedInertialLimit) {
                  validValues.push(line.distance);
              }

              if (!reachedInertialLimit && !validValuesStarted) {

                  validValues.push(line.distance);
                  validValuesStarted = true;
              }

              if (/* distanceWhileInertialDriftIsValidInMeters <=0 */ (lastCoverageNSE
                      + this.calculateNSEByDistance(distanceSinceLastSyncInMeters, aircraftSpeed)) > this.maxNSE) {
                  reachedInertialLimit = true;
              }
              if (reachedInertialLimit) {

                  if (!validValuesClosed) {
                      validValues.push(line.distance);
                      validValues = [];
                      validValuesClosed = true;
                  }

                  invalidcoordinates.push(new coordinate(line.centerLatitude, line.centerLongitude,
                          line.centerHeigth));

                  // Transition from valid to invalid. Add the valid coordinates and reset the
                  // array
                  if (validcoordinates.length > 0) {
                      validcoordinates.push(new coordinate(line.centerLatitude, line.centerLongitude,
                              line.centerHeigth));
                      returnMap.get("VALID").push(validcoordinates);
                      validcoordinates = [];
                  }
              } else {
                  validcoordinates.push(new coordinate(line.centerLatitude, line.centerLongitude,
                          line.centerHeigth));
              }
          }
          lastDistance = line.distance;
          lastLongitude = line.centerLongitude;
          lastLatitude = line.centerLatitude;
          lastAltitude = line.centerHeigth;
      }

      if (!isCurrentlyCovered && reachedInertialLimit) {
          returnMap.get("INVALID").push(invalidcoordinates);
      }

      if (isCurrentlyCovered && coveragecoordinates.length > 0) {
          returnMap.get("COVERAGE").push(coveragecoordinates);
      }

      if (!isCurrentlyCovered && !reachedInertialLimit) {
          returnMap.get("VALID").push(validcoordinates);
      }
    }
    return returnMap;
  }

  public static generateInertialDriftLayer(procedure_type : string, aircraftSpeed : number, runawayValue : number, horizontalUnits : string, results : ProcedurePerformanceLine[], worstValue : boolean, mapService : MapService,
    calculationService : CalculationsService, modalConfirmation : ModalConfirmationService) : Feature[] {

    var layers = [];
    this.features = [];

    let calculatedSegments :  Map<string, coordinate[][]> = this.calculateInertialDrift(procedure_type, aircraftSpeed, runawayValue, horizontalUnits, results, worstValue);
    let allInvalidSegments : coordinate[][] = calculatedSegments.get("INVALID");
    let allValidSegments : coordinate[][] = calculatedSegments.get("VALID");
    let allCoverageSegments : coordinate[][] = calculatedSegments.get("COVERAGE");

    this.fillLayerFeaturesWithValidSegments(0, allInvalidSegments, mapService, calculationService);
    this.fillLayerFeaturesWithValidSegments(1, allValidSegments, mapService, calculationService);
    this.fillLayerFeaturesWithValidSegments(2, allCoverageSegments, mapService, calculationService);

    return this.features;
  }

  private static fillLayerFeaturesWithValidSegments(segmentType : number, allSegments : coordinate[][], mapService : MapService, calculationService : CalculationsService) {

    let ct : number = 0;

    allSegments.forEach( coords =>{
      for (let i : number = 0; i < coords.length - 1; i++) {
        let initialCoord : coordinate = coords[i];
        let finalCoord : coordinate = coords[i + 1];

        /*let coordinate1: Coordinate = [initialCoord.longitude, initialCoord.latitude];
        coordinate1 = olProj.fromLonLat(coordinate1);

        let coordinate2: Coordinate = [finalCoord.longitude, finalCoord.latitude];
        coordinate2 = olProj.fromLonLat(coordinate2);*/


        let points = [];

        points.push([
          initialCoord.longitude,
          initialCoord.latitude,
        ]);
        points.push([
          finalCoord.longitude,
          finalCoord.latitude,
        ]);

        for (var j = 0; j < points.length; j++) {
          points[j] = olProj.transform(points[j], 'EPSG:4326', mapService.getMaps().getView().getProjection());
        }

        let feat = new Feature({
          geometry: new LineString(points),
          type: "InertialDrift",
          featureType : FeatureType.InertialDrift,
        });

        var fill;
        var stroke;

        switch (segmentType) {
          case 0:
            fill = calculationService.colorMap.get('INERTIAL_DRIFT')[0];
            stroke = calculationService.colorMap.get('INERTIAL_DRIFT')[0];
            break;
          case 1:
            fill = calculationService.colorMap.get('INERTIAL_DRIFT')[1];
            stroke = calculationService.colorMap.get('INERTIAL_DRIFT')[1];
            break;
          case 2:
            fill = calculationService.colorMap.get('INERTIAL_DRIFT')[2];
            stroke = calculationService.colorMap.get('INERTIAL_DRIFT')[2];
            break;
          }

          let style = new Style({
            fill: new Fill( { color: fill}),
            stroke : new Stroke({ color: stroke, width: 5 })
          });

          feat.setStyle(style);

          this.features.push(feat);
      }
    });
  }


  private static feetToMeters(feet:any){
    return feet * 0.3048;
  }

  private static nauticalMilesToMeters(nm : number) {
    return nm * 1852;
  }
  private static metersToNauticalMiles(meters : number) : number{
		let nauticalMiles : number = meters *  0.000539956803;

		return nauticalMiles;
	}

  public static knotsToFeetPerSecond(aircraftSpeed : number){
		let feetsPerSecond = (aircraftSpeed *  1.68780986);
		return feetsPerSecond;
	}

  private static feetPerSecondToKnots(aircraftSpeed : number) : number{
		let knots = aircraftSpeed /  1.68780986;
		return knots;
	}

  private static calculateNSEByDistance(distanceInMeters : number, aircraftSpeed : number) {

		let distance : number = this.metersToNauticalMiles(distanceInMeters);

    let aircraftSpeedFinalValue = aircraftSpeed? this.knotsToFeetPerSecond(aircraftSpeed) : this.aircraftSpeed;
		let aircraftSpeedInKnots : number = this.feetPerSecondToKnots(aircraftSpeedFinalValue); // =1 NM/h

		let time : number = distance / aircraftSpeedInKnots;

		return time * this.worstInertialDrift;

	}
}
